<template>
    <normal-page name="Releases">
        <div class="grid content-center gap-6 grid-cols-[repeat(auto-fill,minmax(min(435px,100%),1fr))]">
            <template
                v-for="(release, i) in releases"
                :key="i"
            >
                <div class="panel flex flex-col p-5 transition-colors duration-300 hover:border-foam/15 sm:p-7">
                    <v-lazy-image
                        :src="release.getImageSrc()"
                        class="image-glow mx-auto max-h-48 rounded-md"
                    />

                    <h2
                        v-text="release.name"
                        class="mt-2 font-serif text-xl font-light italic tracking-wide sm:text-3xl"
                    />

                    <p
                        v-text="release.description"
                        class="mt-2 flex-1 font-light leading-relaxed text-foam/60 text-sm"
                    />

                    <div class="grid grid-cols-2 gap-x-6 border-t border-foam/5 pt-4">
                        <div>
                            <div class="eyebrow">Release</div>
                            <div v-text="release.releasedAt" class="mt-1 text-base text-foam/70" />
                        </div>

                        <div class="text-right">
                            <div class="eyebrow">Format</div>
                            <div v-text="release.releaseformat" class="mt-1 text-base text-foam/70" />
                        </div>
                    </div>

                    <div class="">
                        <spotify-player
                            v-if="release.isSpotify()"
                            :id="release.playerRoute"
                        />

                        <bandcamp-player
                            v-if="release.isBandcamp()"
                            :route="release.playerRoute"
                            :is-track="true"
                            :name="release.name"
                        />
                    </div>
                </div>
            </template>
        </div>
    </normal-page>
</template>

<script>
    // Components
    import VLazyImage from 'v-lazy-image';
    import { defineComponent } from 'vue';
    import NormalPage from '@/components/layout/pages/NormalPage';
    import SpotifyPlayer from '@/components/players/SpotifyPlayer';
    import BandcampPlayer from '@/components/players/BandcampPlayer';
    // Library
    import store from '@/store/store';

    export default defineComponent({
        name: 'ReleasesView',

        components: {
            BandcampPlayer,
            NormalPage,
            VLazyImage,

            SpotifyPlayer,
        },

        setup() {
            return {
                releases: store.getters.releases,
            };
        },
    });
</script>
